import { createContext, useContext, useEffect, useState } from 'react';
import { THEMES, DEFAULT_THEME_KEY } from '../utils/themes';

const ThemeContext = createContext(null);

// All variable names ever defined across any theme — cleared before applying a new theme
// so no "ghost" values from a previous theme leak through.
const ALL_THEME_VARS = [...new Set(THEMES.flatMap(t => Object.keys(t.vars)))];

export function ThemeProvider({ children }) {
  const [themeKey, setThemeKey] = useState(
    () => localStorage.getItem('prvsk_theme_v4') || DEFAULT_THEME_KEY
  );

  const theme = THEMES.find(t => t.key === themeKey) || THEMES[0];

  useEffect(() => {
    const root = document.documentElement;
    // Clear every variable any theme might have set before applying the new ones
    ALL_THEME_VARS.forEach(k => root.style.removeProperty(k));
    Object.entries(theme.vars).forEach(([k, v]) => root.style.setProperty(k, v));
    root.setAttribute('data-theme', themeKey);
    localStorage.setItem('prvsk_theme_v4', themeKey);
  }, [themeKey, theme]);

  const switchTheme = (key) => setThemeKey(key);

  return (
    <ThemeContext.Provider value={{ themeKey, theme, themes: THEMES, switchTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
